import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from "../../models/field.interface";
import * as _ from 'lodash';
import { ValidationService, ValidationType } from '../../services/validation.service';
@Component({
  selector: 'app-multi-choice-list',
  template: `
<div [formGroup]="group" *ngIf="field.style.visibility">
  <div class="hazard-description radio-buttons multi-slect-radiolist">
    <p class="dynamic-paragraph">{{field.name}}<b *ngIf="field.validation.isRequired">*</b></p>
    <div class="dropdown">
      <button data-toggle="dropdown" [ngClass]="{'pointer-events' : !field.style.editability}" aria-haspopup="true" aria-expanded="false" type="button">
        <span [ngClass]="{'fr-slect' : selectValue}">{{(selectValue) ? selectValue : 'Select'}}</span>
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu">
        <li>
          <input class="form-control" placeholder="search" [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}">
        </li>
        <li>
          <mat-radio-group class="example-radio-group" *ngFor="let item of field.data | keys  | multiChoiceList:searchText;let i = index">
            <mat-radio-button class="example-radio-button" (change)="onChange(item)" [checked]="selected() === item.key" [value]="item.key">
              {{item.value}}
          </mat-radio-button>
          </mat-radio-group>
        </li>
      </ul>
    </div>
    <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
  </div>
</div>
`,
  styles: [`.multi-slect-radiolist {float: left;width: 98%;}.dropdown .fr-slect{text-transform : lowercase!important;}`]
})
export class MultiChoiceListComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  selectValue;
  constructor(
    private _validationService: ValidationService
  ) { }
  onChange(selectedItem) {
    let selectedOption = {};
    selectedOption[selectedItem.key] = selectedItem.value;
    this.field.value = selectedOption;
    this.selectValue = Object.values(this.field.value);
    this.group.value[this.field.id] = this.field.value;
    const data = this.group.value;
    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
  }
  selected() {
    if (this.field.value && this.field.value !== " ") {
      const items = Object.keys(this.field.value);
      return items[0];
    }
  }
  ngOnInit() {
    if(this.field.value && this.field.value !== " "){
      this.selectValue = Object.values(this.field.value);
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/rFF/fields/multi-choice-list/multi-choice-list.component.ts